import { render, staticRenderFns } from "./CommunityPopupNoticeCreate.vue?vue&type=template&id=35125930&scoped=true"
import script from "./CommunityPopupNoticeCreate.vue?vue&type=script&lang=js"
export * from "./CommunityPopupNoticeCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityPopupNoticeCreate.vue?vue&type=style&index=0&id=35125930&prod&lang=scss&scoped=true"
import style1 from "./CommunityPopupNoticeCreate.vue?vue&type=style&index=1&id=35125930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35125930",
  null
  
)

export default component.exports